export var TransactionType;
(function (TransactionType) {
    TransactionType["EXPENSE"] = "EXPENSE";
    TransactionType["INCOME"] = "INCOME";
    TransactionType["TRANSFER"] = "TRANSFER";
    // Money received that repays an expense the user fronted (not income).
    TransactionType["REIMBURSEMENT"] = "REIMBURSEMENT";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=transaction-type.enum.js.map